import { render } from "./ProductController.vue?vue&type=template&id=4ce30150"
import script from "./ProductController.vue?vue&type=script&lang=js"
export * from "./ProductController.vue?vue&type=script&lang=js"

import "./ProductController.vue?vue&type=style&index=0&id=4ce30150&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__